











































import Vue, { PropType } from 'vue'
import Component from 'vue-class-component'
import Modal from '@/components/Modal.vue'
import ErrorMessages from '@/components/ErrorMessages.vue'
import RadioButton from '@/components/RadioButton.vue'
import { EStatmentDownloadOption, IBatch, ILettersFiltersDTO, IStatementListFilterDTO } from '@zunta/configurations'
import { getModule } from 'vuex-module-decorators'
import { StatementModule } from '@/store/modules/statement.module'
import { checkObjectForNullOrEmptyArray } from '@/utils/helpers'
type statementDownloadOption = { downloadType: EStatmentDownloadOption, referenceType: 'batch' | 'resident' }

@Component({
  components: {
    RadioButton,
    ErrorMessages,
    Modal
  },
  props: {
    batch: {
      type: Object as PropType<IBatch>
    },
    residentId: {
      type: Number
    },
    isUnmailedTab: {
      type: Boolean
    },
    isStatementsMailingPage: {
      type: Boolean
    },
    filteredStatementListCount: {
      type: Number
    },
    useQuery: {
      type: Boolean
    }
  }
})
export default class DownloadModal extends Vue {
  statementModuleInstance: StatementModule = getModule(StatementModule, this.$store)
  currentStatementOptions: statementDownloadOption = this.statementOptions
  statementDownloadOption = EStatmentDownloadOption
  batch: IBatch = this.$props.batch
  isStatementsMailingPage: boolean = this.$props.isStatementsMailingPage
  changeDownloadOption (value: EStatmentDownloadOption) {
    this.currentStatementOptions.downloadType = value
  }
  get statementOptions (): statementDownloadOption {
    if (this.$props.isStatementsMailingPage) {
      return {
        downloadType: this.$props.isUnmailedTab ? EStatmentDownloadOption.NOT_MAILED : EStatmentDownloadOption.MAILED,
        referenceType: 'batch'
      }
    }
    return { downloadType: EStatmentDownloadOption.ALL, referenceType: this.referenceType }
  }
  get referenceType (): 'batch' | 'resident' {
    return this.batch || this.isStatementsMailingPage ? 'batch' : 'resident'
  }
  get query () {
    return this.$route.query
  }
  async downloadZip () {
    this.$emit('close')
    this.$eventBus.$emit('downloading', true)
    const id = this.currentStatementOptions.referenceType === 'batch' ? this.batch.id : this.$props.residentId as number
    const statementFilters: IStatementListFilterDTO | ILettersFiltersDTO = this.$props.useQuery ? { ...this.query } : {}
    Object.keys(statementFilters)
      .forEach(key => checkObjectForNullOrEmptyArray(statementFilters, key) && delete statementFilters[key as keyof (IStatementListFilterDTO | ILettersFiltersDTO)])
    statementFilters.limit && delete statementFilters.limit
    switch (this.currentStatementOptions.downloadType) {
      case EStatmentDownloadOption.MAILED:
        statementFilters.mailed = 'mailed'
        break
      case EStatmentDownloadOption.NOT_MAILED:
        statementFilters.mailed = 'unmailed'
        break
    }
    const { hasCorruptFiles, message } = await this.statementModuleInstance.fetchStatementsZip(
      { statementReferenceId: { id, type: this.currentStatementOptions.referenceType }, filtersDTO: statementFilters }
    )
    this.$eventBus.$emit('downloading', false)
    if (hasCorruptFiles) {
      this.$eventBus.$emit('hasCorruptFiles', message)
    }
  }
}
